<span (dblclick)="toggleTimeDisplayType()">
	@if (shouldShowAbsoluteTime) {
		{{ getAbsoluteTime(relativeTime) | date: (T.DATE_FORMAT_TIME_LONG | translate) :'': translate.currentLang }}
	} @else {
		{{ relativeTime | mmss }}
	}
</span>
